export default defineI18nLocale(async () => {
    const { translation } = await import('~/utils/base-language');
    return translation;
});
